export var SwitchSize;
(function (SwitchSize) {
    SwitchSize["sm"] = "sm";
    SwitchSize["md"] = "md";
})(SwitchSize || (SwitchSize = {}));
export var SwitchVariants;
(function (SwitchVariants) {
    SwitchVariants["primary"] = "primary";
    SwitchVariants["error"] = "error";
})(SwitchVariants || (SwitchVariants = {}));
